import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton, Tooltip } from "@similarweb/ui-components";

import { commonKeys } from "app/pages/sales-intelligence/utils/i18n/common";

type Props = {
    isDisabled?: boolean;
    onClick: VoidFunction;
};

const FilterClearButton = ({ isDisabled = false, onClick }: Props) => {
    const { translate } = useTranslate();

    return (
        <Tooltip
            enabled={!isDisabled}
            content={translate(commonKeys.clear)}
        >
            <IconButton
                type="flat"
                iconName="rubber-band-icon"
                dataAutomation="clear-filter-button"
                isDisabled={isDisabled}
                onClick={onClick}
            />
        </Tooltip>
    );
};

export default FilterClearButton;
